export default __webpack_public_path__ + "static/al-fd6eef3e9106771ccd3b53dcc301d495.svg";